import { ReviewItemFieldsFragment } from "@api/graphql/types-and-hooks";
import { Timestamp } from "@components/QaReview/components/Timestamp";
import { getReviewUserDisplay } from "@components/QaReview/components/commentAuthor";

export const ResolutionLabel: React.FC<{ comment: ReviewItemFieldsFragment }> = ({ comment }) => {
  const { status, resolvedBy, resolvedAt } = comment;
  const statusLabel = status === "applied" ? "Applied" : "Resolved";
  if (comment.__typename !== "ReportCommentType") return <>{statusLabel}</>;

  return (
    <>
      {statusLabel}
      {resolvedBy && ` by ${getReviewUserDisplay(resolvedBy).name}`}
      {resolvedAt && (
        <>
          {" · "}
          <Timestamp value={resolvedAt} />
        </>
      )}
    </>
  );
};
